import type { ComponentProps, FC, PropsWithChildren } from "react";

import { ScrollArea } from "@recobra/ui/scroll-area";
import { TabsContent } from "@recobra/ui/tabs";

/** Scrolling body of a full-height record page, inset by the page gutter, so the header above it stays in place. */
export const DetailPageBody: FC<PropsWithChildren> = ({ children }) => (
  <ScrollArea className="min-h-0 flex-1">
    <div className="flex flex-col gap-4 p-4">{children}</div>
  </ScrollArea>
);

/** Record page tab panel whose content scrolls in a {@link DetailPageBody}. */
export const DetailPageTabPanel: FC<ComponentProps<typeof TabsContent>> = ({
  children,
  ...props
}) => (
  <TabsContent className="flex min-h-0 flex-col" {...props}>
    <DetailPageBody>{children}</DetailPageBody>
  </TabsContent>
);
